import { useLocation, Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";

interface RecoveryPayload {
  token: string;
  email: string;
  type?: string;
}

const parseRecoveryPayload = (pathname: string): RecoveryPayload | null => {
  const match = pathname.match(/^\/reset-password\/r\/([^/]+)\/?$/);
  if (!match?.[1]) return null;

  try {
    let b64 = match[1].replace(/-/g, "+").replace(/_/g, "/");
    while (b64.length % 4) b64 += "=";

    const decoded = JSON.parse(atob(b64));
    if (decoded?.token && decoded?.email) {
      return {
        token: decoded.token,
        email: decoded.email,
        type: decoded.type || "recovery",
      };
    }
  } catch {
    return null;
  }

  return null;
};

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const recoveryPayload = parseRecoveryPayload(location.pathname);

  useEffect(() => {
    if (!recoveryPayload) return;

    const params = new URLSearchParams({
      token: recoveryPayload.token,
      email: recoveryPayload.email,
      type: recoveryPayload.type || "recovery",
    });

    navigate(`/reset-password?${params.toString()}`, { replace: true });
  }, [navigate, recoveryPayload]);

  useEffect(() => {
    if (recoveryPayload) return;

    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname, recoveryPayload]);

  if (recoveryPayload) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <div className="text-center space-y-2 max-w-md">
          <h1 className="text-2xl font-semibold">Omdirigerar...</h1>
          <p className="text-muted-foreground">
            Vi skickar dig vidare till lösenordsåterställningen.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="text-center space-y-6 max-w-md">
        <h1 className="text-4xl font-bold mb-4">Sidan kunde inte hittas</h1>
        <p className="text-xl text-muted-foreground mb-8">
          Tyvärr kunde vi inte hitta sidan du letar efter. Kontrollera att länken är korrekt eller gå tillbaka till startsidan.
        </p>
        <Link to="/">
          <Button className="w-full sm:w-auto">
            Tillbaka till startsidan
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;